<template>
  <table class="table mb-0 responsive-table">
    <thead class="bg-light">
      <tr>
        <th v-if="documentsEdit" scope="col" class="border-0 id-cell"></th>
        <th v-else scope="col" class="border-0 id-cell">ID</th>
        <th scope="col" class="border-0">Typ dokumentu</th>
        <th scope="col" class="border-0">Nazwa pliku</th>
        <th v-if="isDraft" scope="col" class="border-0 text-center" style="width: 150px;" >Akcje</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-if="showDocument(document.id)"
        v-for="(document, index) in scheduleDocuments"
        :key="document.id" >
        <td>
          <dt></dt>
          <dd v-if="documentsEdit">
            <d-checkbox
              :value="document.id"
              v-model="schedule.documents">
            </d-checkbox>
          </dd>
          <dd v-else>{{ document.id }}</dd>
        </td>
        <td>
          <dt>Typ dokumentu</dt>
          <dd>{{ document.type}}</dd>
        </td>
        <td>
          <dt>Nazwa pliku</dt>
          <dd>
            <a
              href="#"
              @click.prevent="downloadFile(document)">
              {{ document.filename}}
            </a>
          </dd>
        </td>
        <td
          v-if="isDraft"
          class="text-center">
          <dt>Akcje</dt>
          <dd>
            <d-button
              @click.prevent="removeDocument(document)"
              theme="danger">
              <i class="material-icons">delete</i> Usuń
            </d-button>
          </dd>
        </td>
      </tr>
      <tr v-if="scheduleDocuments.length < 1">
        <td
          :colspan="isDraft ? 4 : 3"
          class="text-info text-center">
          Brak dokumentów do wyświetlenia.
        </td>
      </tr>
    </tbody>
  </table>
</template>


<script>
import FileSaver from 'file-saver';
import ClientUtils from '@/utils/client';
import DocumentFormModal from '@/components/client/contract-partials/docs/DocumentFormModal.vue';
import SsDate from '@/components/common/SsDate';
import ContractDocsList from '@/components/client/contract-partials/docs/ContractDocsList.vue'

export default {
  name: 'ContractDocsList',
  components: {
    DocumentFormModal,
    SsDate,
    ContractDocsList
  },
  props: {
    isDraft: {
      required: true,
      type: Boolean
    },
    documentsEdit: {
      default: false,
      type: Boolean
    },
    scheduleDocuments: {
      default: () => [],
      type: Array
    },
    schedule: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    removeDocument (document) {
      Vue.swal({
        title: 'Uwaga',
        html: 'Czy potwierdzasz usunięcie<br /><strong>' + document.type + '</strong><br />z listy dokumentów?<br /><br /><span class="text-danger">Dokument zostanie również usunięty z karty klienta.</span>',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Tak',
        cancelButtonText: 'Nie',
        buttonsStyling: true
      }).then((logout) => {
        if(logout.value){
          axios.post('api/clients/remove-document', {
            id: document.id
          }).then(response => {
          if (response.data.cannot_delete && response.data.cannot_delete === 1) {
            Vue.swal({
              type: 'info',
              html: 'By usunąć dokument <strong>' + document.type + '</strong>,<br /> odepnij go najpierw z&nbsp;umów w&nbsp;których uczestniczy',
              showConfirmButton: true,
            })
          } else {
            Vue.swal({
              type: 'success',
              title: 'Dokument został usunięty.',
              showConfirmButton: true,
            }).then(() => {
              this.$bus.$emit('contract-reload-documents');
            });
          }
          }).catch((errors) => {
            console.log(errors);
          })
        }
      }).catch((errors) => {
        console.log(errors);
      })
    },
    downloadFile (doc) {
      axios.post('api/clients/download-document?date=' + Date.now(),
        {id: doc.id,},
        {responseType: 'blob'}
      ).then(response => {
        let blob = new File([response.data], doc.filename );
        FileSaver.saveAs(blob);
      }).catch((error)=>{
        Vue.swal({
          title: 'Nie udało się pobrać pliku',
          text: 'Wystąpił błąd podczas pobierania. Spróbuj ponownie za jakiś czas.',
          type: 'error',
        });
      });
    },
    showDocument (id) {
      if(!this.documentsEdit){
        return this.schedule.documents.includes(id);
      }
      return true;
    }
  }
}
</script>